import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  CancellationException3b36o9qz53rgr as CancellationException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  VOID7hggqo3abtya as VOID,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  RuntimeException1r3t0zl97011n as RuntimeException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  copyOfwy6h3t5vzqpl as copyOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  createThis2j2avj17cvnv2 as createThis,
  fill3lmv1pckd4inv as fill,
  Enum3alwj03lh1n41 as Enum,
  enumEntries20mr21zbe3az4 as enumEntries,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  lazy2hsh8ze7j6ikd as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  toLongw1zpgk99d84b as toLong,
  Long2qws0ah9gnpki as Long,
  printStackTrace18lnx7a39cni as printStackTrace,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  to2cs3ny02qtbcb as to,
  isArray1hxjqtqy632bc as isArray,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  listOfvhqybd2zx248 as listOf,
  toList383f556t1dixk as toList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimStart1mkod6gyztuyy as trimStart,
  split2bvyvnrlcifjv as split,
  getOrNull1go7ef9ldk0df as getOrNull,
  KProperty02ce7r476m8633 as KProperty0,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class NativeImageRef {}
class Cancellable {}
class CloseableCancellable {}
function cancel(e) {
  return this.n6();
}
class Companion {}
class CancellableGroup {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.pt_1 = ArrayList.j1();
  }
  qt(c) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.pt_1;
    var element = cancellable(c);
    this_0.h(element);
  }
  n6() {
    this.ot(CancellationException.td());
  }
  ot(e) {
    cancel_1(this.pt_1, e);
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.rt_1 = function_0;
  }
  ot(e) {
    return this.rt_1(e);
  }
  o4() {
    return this.rt_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Cancellable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class AutoCloseable$1 {
  constructor($block) {
    this.st_1 = $block;
  }
  n6() {
    return this.st_1();
  }
}
class Companion_0 {
  hi(key) {
    var tmp1_safe_receiver = customEnvironments;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = key.toUpperCase();
      tmp = tmp1_safe_receiver.f3(tmp$ret$1);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = Companion_getInstance_4().vt();
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = key.toUpperCase();
      tmp_0 = tmp_1.f3(tmp$ret$3);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
}
class MalformedInputException extends Exception {
  static bu(msg) {
    var $this = this.a6(msg);
    captureStack($this, $this.au_1);
    return $this;
  }
}
class InvalidOperationException extends Exception {
  static yt(str) {
    str = str === VOID ? 'Invalid Operation' : str;
    var $this = this.a6(str);
    captureStack($this, $this.xt_1);
    return $this;
  }
}
class ReservedException extends Exception {
  static eu(str) {
    str = str === VOID ? 'Reserved' : str;
    var $this = this.a6(str);
    captureStack($this, $this.du_1);
    return $this;
  }
}
class UnreachableException extends Exception {
  static hu(str) {
    str = str === VOID ? 'Unreachable' : str;
    var $this = this.a6(str);
    captureStack($this, $this.gu_1);
    return $this;
  }
}
class OutOfBoundsException extends Exception {
  static ku(index, str) {
    index = index === VOID ? -1 : index;
    str = str === VOID ? 'Out Of Bounds' : str;
    var $this = this.a6(str);
    captureStack($this, $this.ju_1);
    return $this;
  }
}
class ByteArrayBuilder {
  static ou(data, size, allowGrow) {
    size = size === VOID ? data.length : size;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    var $this = createThis(this);
    $this.lu_1 = data;
    $this.mu_1 = allowGrow;
    $this.nu_1 = size;
    return $this;
  }
  static pu(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.ou(new Int8Array(initialCapacity), 0);
  }
  qu(value) {
    var oldPosition = this.nu_1;
    var newPosition = value;
    ensure(this, newPosition);
    this.nu_1 = newPosition;
    if (newPosition > oldPosition) {
      fill(this.lu_1, 0, oldPosition, newPosition);
    }
  }
  f1() {
    return this.nu_1;
  }
  ru(array, offset, len) {
    ensureCount(this, len);
    arraycopy(this, array, offset, this.lu_1, this.nu_1, len);
    this.nu_1 = this.nu_1 + len | 0;
  }
  su(array, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? array.length - offset | 0 : len;
    var tmp;
    if ($super === VOID) {
      this.ru(array, offset, len);
      tmp = Unit_instance;
    } else {
      tmp = $super.ru.call(this, array, offset, len);
    }
    return tmp;
  }
  tu(v) {
    ensure(this, this.nu_1 + 1 | 0);
    var tmp = this.lu_1;
    var _unary__edvuaz = this.nu_1;
    this.nu_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v;
  }
  uu() {
    return copyOf(this.lu_1, this.nu_1);
  }
}
class Companion_1 {
  vu() {
    return get_currentArch();
  }
}
class Arch extends Enum {
  constructor(name, ordinal, bits, isArm, isX86OrX64, isMips, isWasm, isPowerPC) {
    isArm = isArm === VOID ? false : isArm;
    isX86OrX64 = isX86OrX64 === VOID ? false : isX86OrX64;
    isMips = isMips === VOID ? false : isMips;
    isWasm = isWasm === VOID ? false : isWasm;
    isPowerPC = isPowerPC === VOID ? false : isPowerPC;
    super(name, ordinal);
    this.yu_1 = bits;
    this.zu_1 = isArm;
    this.av_1 = isX86OrX64;
    this.bv_1 = isMips;
    this.cv_1 = isWasm;
    this.dv_1 = isPowerPC;
  }
  ev() {
    return this.yu_1 === 32;
  }
  fv() {
    return this.yu_1 === 64;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    this.gv_1 = get_currentIsLittleEndian() ? Endian_LITTLE_ENDIAN_getInstance() : Endian_BIG_ENDIAN_getInstance();
  }
}
class Endian extends Enum {
  jv() {
    return this.equals(Endian_LITTLE_ENDIAN_getInstance());
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.kv_1 = get_entries();
  }
  vu() {
    return get_currentOs();
  }
}
class Os extends Enum {
  nv() {
    return this.equals(Os_WINDOWS_getInstance());
  }
  ov() {
    return this.equals(Os_LINUX_getInstance());
  }
  pv() {
    return this.equals(Os_MACOSX_getInstance());
  }
}
class Platform {}
function get_isWindows() {
  return this.sv().nv();
}
function get_isLinux() {
  return this.sv().ov();
}
function get_isMac() {
  return this.sv().pv();
}
function get_isJs() {
  return this.tv().wv();
}
function get_isNative() {
  return this.tv().xv();
}
function get_isWasm() {
  return this.tv().yv();
}
function get_isJsOrWasm() {
  return this.wv() || this.yv();
}
function get_isJsNodeJs() {
  return this.uv() === 'js-node' || this.uv() === 'wasm-node';
}
function get_isJsDenoJs() {
  return this.uv() === 'js-deno' || this.uv() === 'wasm-deno';
}
function get_isJsBrowser() {
  return this.uv() === 'js-web' || this.uv() === 'wasm-web';
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    tmp.tt_1 = lazy(Platform$Companion$envs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.ut_1 = lazy(Platform$Companion$envsUC$delegate$lambda);
  }
  rv() {
    return Companion_instance_1.vu();
  }
  sv() {
    return Companion_getInstance_3().vu();
  }
  tv() {
    return Companion_instance_5.vu();
  }
  uv() {
    return get_currentRawPlatformName();
  }
  qv() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.tt_1;
    envs$factory();
    return this_0.s1();
  }
  vt() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ut_1;
    envsUC$factory();
    return this_0.s1();
  }
  vv() {
    return get_languages();
  }
}
class Companion_5 {
  vu() {
    return get_currentRuntime();
  }
}
class Runtime extends Enum {
  wv() {
    return this.equals(Runtime_JS_getInstance());
  }
  fw() {
    return this.equals(Runtime_JVM_getInstance());
  }
  xv() {
    return this.equals(Runtime_NATIVE_getInstance());
  }
  yv() {
    return this.equals(Runtime_WASM_getInstance());
  }
}
class IOException extends Exception {
  static mw(msg) {
    var $this = this.a6(msg);
    captureStack($this, $this.lw_1);
    return $this;
  }
}
class FileNotFoundException extends IOException {
  static jw(msg) {
    var $this = this.mw(msg);
    captureStack($this, $this.iw_1);
    return $this;
  }
}
class EOFException extends IOException {
  static qw(msg) {
    var $this = this.mw(msg);
    captureStack($this, $this.pw_1);
    return $this;
  }
}
class Companion_6 {}
class DenoPointer {
  constructor(rawPointer) {
    this.rw_1 = rawPointer;
  }
  toString() {
    return 'DenoPointer(rawPointer=' + toString(this.rw_1) + ')';
  }
  hashCode() {
    return hashCode(this.rw_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DenoPointer))
      return false;
    var tmp0_other_with_cast = other instanceof DenoPointer ? other : THROW_CCE();
    if (!equals(this.rw_1, tmp0_other_with_cast.rw_1))
      return false;
    return true;
  }
}
//endregion
function Closeable(block) {
  return AutoCloseable_0(block);
}
function cancel_0(_this__u8e3s4) {
  return _this__u8e3s4.ot(CancellationException.ud(''));
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function AutoCloseable_0(block) {
  return new AutoCloseable$1(block);
}
function cancellable(_this__u8e3s4) {
  var tmp = cancellable$lambda(_this__u8e3s4);
  return new sam$korlibs_io_lang_Cancellable$0(tmp);
}
function cancel_1(_this__u8e3s4, e) {
  e = e === VOID ? CancellationException.ud('') : e;
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var _iterator__ex2g4s = _this__u8e3s4.b1();
  while (_iterator__ex2g4s.c1()) {
    var c = _iterator__ex2g4s.d1();
    c.ot(e);
  }
  return Unit_instance;
}
function cancellable$lambda($this_cancellable) {
  return function (it) {
    $this_cancellable.n6();
    return Unit_instance;
  };
}
var customEnvironments;
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function unsupported(msg) {
  msg = msg === VOID ? 'unsupported' : msg;
  throw UnsupportedOperationException.la(msg);
}
function invalidOp(msg) {
  throw InvalidOperationException.yt(msg);
}
function get_invalidOp() {
  throw InvalidOperationException.yt();
}
function reserved(msg) {
  throw ReservedException.eu(msg);
}
function get_reserved() {
  throw ReservedException.eu();
}
function get_unreachable() {
  throw UnreachableException.hu();
}
function ensure($this, expected) {
  if ($this.lu_1.length < expected) {
    if (!$this.mu_1)
      throw RuntimeException.wa('ByteArrayBuffer configured to not grow!');
    var newSize = imul($this.lu_1.length + 7 | 0, 5);
    var realNewSize = newSize < 0 ? 1073741823 : newSize;
    if (newSize < 0 && expected > realNewSize) {
      // Inline function 'kotlin.error' call
      var message = "ByteArrayBuffer can't grow that much";
      throw IllegalStateException.h5(toString(message));
    }
    var tmp = $this;
    var tmp_0 = $this.lu_1;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(expected, realNewSize);
    tmp.lu_1 = copyOf(tmp_0, tmp$ret$0);
  }
}
function ensureCount($this, count) {
  ensure($this, $this.nu_1 + count | 0);
}
function arraycopy($this, src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
var Arch_UNKNOWN_instance;
var Arch_X86_instance;
var Arch_X64_instance;
var Arch_ARM32_instance;
var Arch_ARM64_instance;
var Arch_MIPS32_instance;
var Arch_MIPSEL32_instance;
var Arch_MIPS64_instance;
var Arch_MIPSEL64_instance;
var Arch_WASM32_instance;
var Arch_POWERPC64_instance;
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var Arch_entriesInitialized;
function Arch_initEntries() {
  if (Arch_entriesInitialized)
    return Unit_instance;
  Arch_entriesInitialized = true;
  Arch_UNKNOWN_instance = new Arch('UNKNOWN', 0, -1);
  Arch_X86_instance = new Arch('X86', 1, 32, VOID, true);
  Arch_X64_instance = new Arch('X64', 2, 64, VOID, true);
  Arch_ARM32_instance = new Arch('ARM32', 3, 32, true);
  Arch_ARM64_instance = new Arch('ARM64', 4, 64, true);
  Arch_MIPS32_instance = new Arch('MIPS32', 5, 32, VOID, VOID, true);
  Arch_MIPSEL32_instance = new Arch('MIPSEL32', 6, 32, VOID, VOID, true);
  Arch_MIPS64_instance = new Arch('MIPS64', 7, 64, VOID, VOID, true);
  Arch_MIPSEL64_instance = new Arch('MIPSEL64', 8, 64, VOID, VOID, true);
  Arch_WASM32_instance = new Arch('WASM32', 9, 32, VOID, VOID, VOID, true);
  Arch_POWERPC64_instance = new Arch('POWERPC64', 10, 64, VOID, VOID, VOID, VOID, true);
}
function Arch_UNKNOWN_getInstance() {
  Arch_initEntries();
  return Arch_UNKNOWN_instance;
}
var Endian_LITTLE_ENDIAN_instance;
var Endian_BIG_ENDIAN_instance;
var Companion_instance_2;
function Companion_getInstance_2() {
  Endian_initEntries();
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var Endian_entriesInitialized;
function Endian_initEntries() {
  if (Endian_entriesInitialized)
    return Unit_instance;
  Endian_entriesInitialized = true;
  Endian_LITTLE_ENDIAN_instance = new Endian('LITTLE_ENDIAN', 0);
  Endian_BIG_ENDIAN_instance = new Endian('BIG_ENDIAN', 1);
  Companion_getInstance_2();
}
function Endian_LITTLE_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_LITTLE_ENDIAN_instance;
}
function Endian_BIG_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_BIG_ENDIAN_instance;
}
var Os_UNKNOWN_instance;
var Os_WASM_instance;
var Os_LINUX_instance;
var Os_WINDOWS_instance;
var Os_ANDROID_instance;
var Os_MACOSX_instance;
var Os_IOS_instance;
var Os_TVOS_instance;
var Os_WATCHOS_instance;
var Companion_instance_3;
function Companion_getInstance_3() {
  Os_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [Os_UNKNOWN_getInstance(), Os_WASM_getInstance(), Os_LINUX_getInstance(), Os_WINDOWS_getInstance(), Os_ANDROID_getInstance(), Os_MACOSX_getInstance(), Os_IOS_getInstance(), Os_TVOS_getInstance(), Os_WATCHOS_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Os_entriesInitialized;
function Os_initEntries() {
  if (Os_entriesInitialized)
    return Unit_instance;
  Os_entriesInitialized = true;
  Os_UNKNOWN_instance = new Os('UNKNOWN', 0);
  Os_WASM_instance = new Os('WASM', 1);
  Os_LINUX_instance = new Os('LINUX', 2);
  Os_WINDOWS_instance = new Os('WINDOWS', 3);
  Os_ANDROID_instance = new Os('ANDROID', 4);
  Os_MACOSX_instance = new Os('MACOSX', 5);
  Os_IOS_instance = new Os('IOS', 6);
  Os_TVOS_instance = new Os('TVOS', 7);
  Os_WATCHOS_instance = new Os('WATCHOS', 8);
  Companion_getInstance_3();
}
var $ENTRIES;
function Os_UNKNOWN_getInstance() {
  Os_initEntries();
  return Os_UNKNOWN_instance;
}
function Os_WASM_getInstance() {
  Os_initEntries();
  return Os_WASM_instance;
}
function Os_LINUX_getInstance() {
  Os_initEntries();
  return Os_LINUX_instance;
}
function Os_WINDOWS_getInstance() {
  Os_initEntries();
  return Os_WINDOWS_instance;
}
function Os_ANDROID_getInstance() {
  Os_initEntries();
  return Os_ANDROID_instance;
}
function Os_MACOSX_getInstance() {
  Os_initEntries();
  return Os_MACOSX_instance;
}
function Os_IOS_getInstance() {
  Os_initEntries();
  return Os_IOS_instance;
}
function Os_TVOS_getInstance() {
  Os_initEntries();
  return Os_TVOS_instance;
}
function Os_WATCHOS_getInstance() {
  Os_initEntries();
  return Os_WATCHOS_instance;
}
function Platform$Companion$envs$delegate$lambda() {
  return get_envs();
}
function Platform$Companion$envsUC$delegate$lambda() {
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = Companion_getInstance_4().qv();
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap.pc(mapCapacity(this_0.f1()));
  // Inline function 'kotlin.collections.associateByTo' call
  var tmp0_iterator = this_0.q1().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.platform.Companion.envsUC$delegate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = element.r1().toUpperCase();
    // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
    var tmp$ret$3 = element.s1();
    destination.h3(tmp, tmp$ret$3);
  }
  return destination;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function envs$factory() {
  return getPropertyCallableRef('envs', 1, KProperty1, function (receiver) {
    return receiver.qv();
  }, null);
}
function envsUC$factory() {
  return getPropertyCallableRef('envsUC', 1, KProperty1, function (receiver) {
    return receiver.vt();
  }, null);
}
var Runtime_JS_instance;
var Runtime_JVM_instance;
var Runtime_ANDROID_instance;
var Runtime_NATIVE_instance;
var Runtime_WASM_instance;
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var Runtime_entriesInitialized;
function Runtime_initEntries() {
  if (Runtime_entriesInitialized)
    return Unit_instance;
  Runtime_entriesInitialized = true;
  Runtime_JS_instance = new Runtime('JS', 0);
  Runtime_JVM_instance = new Runtime('JVM', 1);
  Runtime_ANDROID_instance = new Runtime('ANDROID', 2);
  Runtime_NATIVE_instance = new Runtime('NATIVE', 3);
  Runtime_WASM_instance = new Runtime('WASM', 4);
}
function Runtime_JS_getInstance() {
  Runtime_initEntries();
  return Runtime_JS_instance;
}
function Runtime_JVM_getInstance() {
  Runtime_initEntries();
  return Runtime_JVM_instance;
}
function Runtime_NATIVE_getInstance() {
  Runtime_initEntries();
  return Runtime_NATIVE_instance;
}
function Runtime_WASM_getInstance() {
  Runtime_initEntries();
  return Runtime_WASM_instance;
}
function get_portableSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.gf();
  return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function get_Deno_isDeno() {
  // Inline function 'kotlin.js.unsafeCast' call
  return 'Deno' in window;
}
function get_pointer(_this__u8e3s4) {
  return new DenoPointer(_this__u8e3s4);
}
function toArray(_this__u8e3s4) {
  return Array.from(_this__u8e3s4);
}
function jsObject(pairs) {
  var out = jsEmptyObj();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var pair = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    out[pair.ll_1] = pair.ml_1;
  }
  return out;
}
function jsNew(clazz) {
  return (new clazz())();
}
function jsEmptyObj() {
  return {};
}
function toLong_0(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = i32[0];
  var low = toLong(tmp$ret$1).j4(new Long(-1, 0));
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = i32[1];
  var high = toLong(tmp$ret$3).j4(new Long(-1, 0));
  return low.k4(high.g4(32));
}
function toJsBigInt(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[0] = _this__u8e3s4.i4(0).j2();
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[1] = _this__u8e3s4.i4(32).j2();
  return get(bi64, 0);
}
function get(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.asDynamic' call
  return BigInt(_this__u8e3s4[index]);
}
function get_isDenoJs() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isDenoJs$delegate;
  isDenoJs$factory();
  return this_0.s1();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWeb$delegate;
  isWeb$factory();
  return this_0.s1();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWorker$delegate;
  isWorker$factory();
  return this_0.s1();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isNodeJs$delegate;
  isNodeJs$factory();
  return this_0.s1();
}
var isNodeJs$delegate;
function get_currentArch() {
  _init_properties_Current_js_kt__w11d1e();
  return currentArch;
}
var currentArch;
function get_currentRuntime() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRuntime;
}
var currentRuntime;
var currentIsDebug;
function get_currentIsLittleEndian() {
  _init_properties_Current_js_kt__w11d1e();
  return currentIsLittleEndian;
}
var currentIsLittleEndian;
var multithreadedSharedHeap;
function get_currentRawPlatformName() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRawPlatformName;
}
var currentRawPlatformName;
var currentRawOsName;
function get_envs() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = envs$delegate;
  envs$factory_0();
  return this_0.s1();
}
var envs$delegate;
function get_isShell() {
  _init_properties_Current_js_kt__w11d1e();
  return !get_isWeb() && !get_isNodeJs() && !get_isWorker();
}
function get_process() {
  _init_properties_Current_js_kt__w11d1e();
  if (typeof process === 'undefined') {
    try {
      // Inline function 'kotlin.error' call
      var message = "Not in NodeJS. Can't access process";
      throw IllegalStateException.h5(toString(message));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        throw e;
      } else {
        throw $p;
      }
    }
  }
  return process;
}
function jsObjectToMap(obj) {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = jsObjectKeysArray(obj);
  var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.pc(capacity);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.platform.jsObjectToMap.<anonymous>' call
    var pair = to(element, obj[element]);
    destination.h3(pair.ll_1, pair.ml_1);
  }
  return destination;
}
function jsObjectKeysArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = jsToArray(jsObjectKeys(obj));
  return isArray(tmp) ? tmp : THROW_CCE();
}
function jsToArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = 0;
  var tmp_0 = obj.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = fillArrayVal(Array(tmp_0), null);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = obj[tmp_2];
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function jsObjectKeys(obj) {
  _init_properties_Current_js_kt__w11d1e();
  return Object.keys(obj);
}
function get_jsGlobalThis() {
  _init_properties_Current_js_kt__w11d1e();
  return globalThis;
}
function get_languages() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var navigator = get_jsGlobalThis().navigator;
  var envs = Companion_getInstance_4().qv();
  var tmp;
  // Inline function 'kotlin.js.asDynamic' call
  if (navigator) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList(navigator.languages);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.platform.<get-languages>.<anonymous>' call
      var tmp$ret$3 = toString(item);
      destination.h(tmp$ret$3);
    }
    tmp = destination;
  } else {
    var tmp0_elvis_lhs = envs.f3('LANG');
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? envs.f3('LANGUAGE') : tmp0_elvis_lhs;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? envs.f3('LC_ALL') : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? envs.f3('LC_MESSAGES') : tmp2_elvis_lhs;
    tmp = listOf(tmp3_elvis_lhs == null ? 'en-GB' : tmp3_elvis_lhs);
  }
  return tmp;
}
function get_currentOs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs()) {
    switch (Deno.build.os) {
      case 'darwin':
        tmp = Os_MACOSX_getInstance();
        break;
      case 'linux':
        tmp = Os_LINUX_getInstance();
        break;
      case 'windows':
        tmp = Os_WINDOWS_getInstance();
        break;
      default:
        tmp = Os_UNKNOWN_getInstance();
        break;
    }
  } else {
    tmp = Os_UNKNOWN_getInstance();
  }
  return tmp;
}
function isDenoJs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function isWeb$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function isWorker$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function isNodeJs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function envs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs()) {
    tmp = jsObjectToMap(Deno.env.toObject());
  } else if (get_isNodeJs()) {
    tmp = jsObjectToMap(get_process().env);
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = LinkedHashMap.oc();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.platform.envs$delegate.<anonymous>.<anonymous>' call
    var tmp1_safe_receiver = document.location;
    var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.search;
    var hash = trimStart(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, charArrayOf([_Char___init__impl__6a9atx(63)]));
    var _iterator__ex2g4s = split(hash, ['&']).b1();
    while (_iterator__ex2g4s.c1()) {
      var part = _iterator__ex2g4s.d1();
      var parts = split(part, ['=']);
      var key = decodeURIComponent(parts.e1(0));
      var tmp1_elvis_lhs = getOrNull(parts, 1);
      var value = decodeURIComponent(tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      this_0.h3(key, value);
    }
    tmp = this_0;
  }
  return tmp;
}
function isDenoJs$factory() {
  return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
    return get_isDenoJs();
  }, null);
}
function isWeb$factory() {
  return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
    return get_isWeb();
  }, null);
}
function isWorker$factory() {
  return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
    return get_isWorker();
  }, null);
}
function isNodeJs$factory() {
  return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
    return get_isNodeJs();
  }, null);
}
function envs$factory_0() {
  return getPropertyCallableRef('envs', 0, KProperty0, function () {
    return get_envs();
  }, null);
}
var properties_initialized_Current_js_kt_4h6d9c;
function _init_properties_Current_js_kt__w11d1e() {
  if (!properties_initialized_Current_js_kt_4h6d9c) {
    properties_initialized_Current_js_kt_4h6d9c = true;
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    currentArch = Arch_UNKNOWN_getInstance();
    currentRuntime = Runtime_JS_getInstance();
    currentIsDebug = false;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [287454020];
    // Inline function 'kotlin.js.asDynamic' call
    currentIsLittleEndian = (new Uint8Array((new Uint32Array(tmp$ret$2)).buffer))[0] === 68;
    multithreadedSharedHeap = false;
    currentRawPlatformName = get_isDenoJs() ? 'js-deno' : get_isWeb() ? 'js-web' : get_isNodeJs() ? 'js-node' : get_isWorker() ? 'js-worker' : get_isShell() ? 'js-shell' : 'js';
    var tmp;
    if (get_isDenoJs()) {
      tmp = 'deno';
    } else if (get_isWeb() || get_isWorker()) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = navigator.userAgent;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = get_process().platform;
    }
    currentRawOsName = tmp;
    envs$delegate = lazy(envs$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForInterface(NativeImageRef, 'NativeImageRef');
initMetadataForInterface(Cancellable, 'Cancellable');
initMetadataForInterface(CloseableCancellable, 'CloseableCancellable', VOID, VOID, [AutoCloseable, Cancellable]);
initMetadataForCompanion(Companion);
initMetadataForClass(CancellableGroup, 'CancellableGroup', CancellableGroup, VOID, [CloseableCancellable]);
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0', VOID, VOID, [Cancellable, FunctionAdapter]);
initMetadataForClass(AutoCloseable$1, VOID, VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(MalformedInputException, 'MalformedInputException');
initMetadataForClass(InvalidOperationException, 'InvalidOperationException', InvalidOperationException.yt);
initMetadataForClass(ReservedException, 'ReservedException', ReservedException.eu);
initMetadataForClass(UnreachableException, 'UnreachableException', UnreachableException.hu);
initMetadataForClass(OutOfBoundsException, 'OutOfBoundsException', OutOfBoundsException.ku);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', ByteArrayBuilder.pu);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Arch, 'Arch');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Endian, 'Endian');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Os, 'Os');
initMetadataForInterface(Platform, 'Platform');
protoOf(Companion_4).nv = get_isWindows;
protoOf(Companion_4).ov = get_isLinux;
protoOf(Companion_4).pv = get_isMac;
protoOf(Companion_4).wv = get_isJs;
protoOf(Companion_4).xv = get_isNative;
protoOf(Companion_4).yv = get_isWasm;
protoOf(Companion_4).zv = get_isJsOrWasm;
protoOf(Companion_4).aw = get_isJsNodeJs;
protoOf(Companion_4).bw = get_isJsDenoJs;
protoOf(Companion_4).cw = get_isJsBrowser;
initMetadataForCompanion(Companion_4, VOID, [Platform]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Runtime, 'Runtime');
initMetadataForClass(IOException, 'IOException');
initMetadataForClass(FileNotFoundException, 'FileNotFoundException');
initMetadataForClass(EOFException, 'EOFException');
initMetadataForCompanion(Companion_6);
initMetadataForClass(DenoPointer, 'DenoPointer');
//endregion
//region block: init
Companion_instance = new Companion();
customEnvironments = null;
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
//endregion
//region block: exports
export {
  Endian_BIG_ENDIAN_getInstance as Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd,
  Endian_LITTLE_ENDIAN_getInstance as Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil,
  Os_UNKNOWN_getInstance as Os_UNKNOWN_getInstancecnx3cm3i6e2g,
  Companion_instance_0 as Companion_instance1mbrm9vk5fsmd,
  Companion_getInstance_3 as Companion_getInstance39o54489czp6d,
  Companion_getInstance_4 as Companion_getInstancegk7jn4e7je7g,
  NativeImageRef as NativeImageRefqizti6jm75,
  CancellableGroup as CancellableGroup3e8z70ga3djg,
  Cancellable as Cancellable3gmnln785cfrg,
  cancel as cancel1amaozv14ic7s,
  CloseableCancellable as CloseableCancellable3mxnqaxyfppmn,
  Closeable as Closeable2m9yv0b0gma2l,
  EOFException as EOFExceptiona2wwqnj55hh5,
  FileNotFoundException as FileNotFoundException2tz8ve019qipn,
  IOException as IOException33c9ezfvq1zr9,
  MalformedInputException as MalformedInputException12cxjt7zq8psv,
  OutOfBoundsException as OutOfBoundsException1k0x58dcca6fx,
  cancel_0 as cancel1n0qjc93h2v6w,
  get_invalidOp as get_invalidOp31x7cztl0dv9m,
  invalidOp as invalidOp1stebxh2m3n07,
  get_portableSimpleName as get_portableSimpleName6o7s8nc63i85,
  get_reserved as get_reserved2d9gxjta2y60d,
  reserved as reserved38luap2kxmc9d,
  get_unreachable as get_unreachable2fi7msfg0vgzd,
  unsupported as unsupported198cz39rr1ztw,
  DenoPointer as DenoPointerpb0vypijx63v,
  get_Deno_isDeno as get_Deno_isDeno1rvz34wr12yh3,
  jsNew as jsNewco39te1yl3up,
  jsObject as jsObjectr1r5ao37ef4f,
  get_pointer as get_pointerlkbwhoqlhapz,
  toArray as toArray1y3va21vj7n9x,
  toJsBigInt as toJsBigInt2lj477tra3oly,
  toLong_0 as toLong12oqfsfu42e35,
  ByteArrayBuilder as ByteArrayBuilderyrflhqjz64ju,
  get_jsGlobalThis as get_jsGlobalThis3odmbn60utci,
};
//endregion
